import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
  selector: '[errorStateWithLength]'
})
export class ErrorStateWithLengthDirective {
  @Input('hasFormError') hasFormError: boolean
  @Input('isInValid') isInValid: boolean

  @HostBinding('class.interval-required')
  get intervalRequiredClass() {
    if (!this.hasFormError) return true;
    return false
  }

  @HostBinding('class.interval-error')
  get intervalErrorClass() {
    if (this.hasFormError && this.isInValid) return true;
    return false
  }

  @HostBinding('hidden')
  get hidden() {
    return this.isInValid === false
  }
}